module.exports = __webpack_public_path__ + "static/img/269.8ede414.png";